import React from "react";

const AccountInsightsIcon = ({ color = "#EFF0F6", ...props }) => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4 20V10H7V20H4ZM10 20V6H13V20H10ZM16 20V13H19V20H16Z"
				fill={color}
			/>
		</svg>
	);
};

export default AccountInsightsIcon;
